@if (show && !details) {
  <mat-list-item>
    @if (!completed && !icon) {
      <mat-progress-spinner
        color="primary"
        mode="indeterminate"
        diameter="20"
        strokeWidth="3"
        aria-label="Processing in progress">
      </mat-progress-spinner>
    }
    @if (!completed && !!icon) {
      <mat-icon mat-list-icon color="primary" [style.vertical-align]="'middle'" [style.margin-right]="'10px'">{{ icon }}</mat-icon>
    }
    @if (completed && !failed) {
      <mat-icon mat-list-icon color="primary" [style.vertical-align]="'middle'" [style.margin-right]="'10px'">check_circle</mat-icon>
    }
    @if (completed && failed) {
      <mat-icon mat-list-icon color="primary" [style.vertical-align]="'middle'" [style.margin-right]="'10px'">info</mat-icon>
    }
    {{ text }}
    <ng-content></ng-content>
  </mat-list-item>
}

@if (show && details) {
  <mat-expansion-panel class="batch-error" icon="info">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon mat-list-icon color="primary">info</mat-icon>
        {{ text }}
      </mat-panel-title>
      <mat-panel-description>
        Click to expand for details
      </mat-panel-description>
    </mat-expansion-panel-header>
    <p>
      {{ details }}
    </p>
    <mat-action-row>
      @for (action of actions; track action) {
        <button mat-button
          color="primary"
          ecaThrottleClick
          (throttleClick)="dispatch(action.dispatch)">
          {{ action.label }}
        </button>
      }
    </mat-action-row>
  </mat-expansion-panel>
}
